import cn from 'classnames';

import CheckCircle from 'components/icons/accent/CheckCircle';
import CloseX from 'components/icons/navigation/CloseX';

export const COLOR_SCHEME_GREEN = 'green';
export const COLOR_SCHEME_GRAY = 'gray';
export const COLOR_SCHEME_RED = 'red';
export const COLOR_SCHEME_NONE = 'none';

const ModalNoFocus = ({
  bodyStyle = '',
  explicitBodyStyle = false,
  bottomDismissable = true,
  colorScheme = COLOR_SCHEME_GREEN,
  containerStyle = '',
  dismissable = true,
  iconComponent: Icon = CheckCircle,
  onDismiss = () => {},
  showIcon = true,
  title = '',
  titleTextClass = '',
  topBarStyle = '',
  explicitTopBarStyle = false,
  xStyle = '',
  children,
  mainContentClass,
  explicitMainContentClass = false,
  mainContentRef,
}) => (
  <div className="react-modal pointer-events-none">
    <div
      className={cn(
        // use directional-center to center modal, BottomSheetModal is handling centering in its
        // own stylesheet because of other css load issues
        containerStyle,
        'fixed',
        'p-4',
        'min-w-300',
        'min-h-300',
        'max-h-screen',
        'z-bottomSheet',
        'max-w-600'
      )}
    >
      <div
        className={
          explicitMainContentClass
            ? cn(mainContentClass)
            : cn(
                mainContentClass,
                'w-full',
                'max-h-90vh',
                'bg-white-100',
                'rounded',
                'border',
                'border-charcoal-60'
              )
        }
        id="modalNoFocusMainContent"
        ref={mainContentRef}
      >
        <div
          className={
            explicitTopBarStyle
              ? cn(topBarStyle)
              : cn(
                  topBarStyle,
                  'top-0',
                  'flex',
                  'justify-between',
                  'items-center',
                  'p-5',
                  'bp1:py-3',
                  'pl-5',
                  'rounded-t',
                  {
                    'bg-green-100 text-white-100': colorScheme === COLOR_SCHEME_GREEN,
                    'bg-red-100 text-white-100': colorScheme === COLOR_SCHEME_RED,
                    'bg-ice-100 text-charcoal-100': colorScheme === COLOR_SCHEME_GRAY,
                  }
                )
          }
        >
          <div className="flex items-center">
            {showIcon && <Icon className="iconLg mr-4" />}
            <span className={titleTextClass ? titleTextClass : 'h2'}>{title}</span>
          </div>
          {dismissable && (
            <button onClick={onDismiss} className={xStyle}>
              <span className="sr">Close</span>
              <CloseX className="h-6 w-6" />
            </button>
          )}
        </div>
        <div
          className={
            explicitBodyStyle ? cn(bodyStyle) : cn(bodyStyle, 'p-5', 'bp1:pt-6', 'bp1:pb-8')
          }
        >
          {children}
        </div>
      </div>
    </div>

    {bottomDismissable ? (
      <button
        onClick={onDismiss}
        className="fixed left-0 top-0 z-bottomSheetBackground h-screen w-full cursor-default"
      />
    ) : (
      <div className="fixed left-0 top-0 z-bottomSheetBackground h-screen w-full" />
    )}
  </div>
);

ModalNoFocus.propTypes = {
  bodyStyle: PropTypes.string,
  colorScheme: PropTypes.oneOf([
    COLOR_SCHEME_GREEN,
    COLOR_SCHEME_GRAY,
    COLOR_SCHEME_RED,
    COLOR_SCHEME_NONE,
  ]),
  containerStyle: PropTypes.string,
  dismissable: PropTypes.bool,
  iconComponent: PropTypes.func,
  onDismiss: PropTypes.func,
  showIcon: PropTypes.bool,
  title: PropTypes.string,
  topBarStyle: PropTypes.string,
  xStyle: PropTypes.string,
  titleTextClass: PropTypes.string,
  bottomDismissable: PropTypes.bool,
  explicitBodyStyle: PropTypes.bool,
  explicitTopBarStyle: PropTypes.bool,
  explicitMainContentClass: PropTypes.bool,
  children: PropTypes.node,
  mainContentClass: PropTypes.string,
  mainContentRef: PropTypes.object,
};

export default ModalNoFocus;
